<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Vacina idade certa"
            description="Registro de vacinação por cidadão"
            url="/imunizacao"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img v-else-if="item.imagem !== ''" :src="item.imagem" alt="" />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '../../../components/Menu'
import Footer from '../../../components/Footer'
import SectionTitle from '../../../components/SectionTitle'
import Covid19Infantil from '@/components/icons/Imunizacao/VacinaIdadeCerta/Covid19Infantil'
import Varicela from '@/components/icons/Imunizacao/VacinaIdadeCerta/Varicela'
import Dtp from '@/components/icons/Imunizacao/VacinaIdadeCerta/Dtp'
import Pneumo from '@/components/icons/Imunizacao/VacinaIdadeCerta/Pneumo'
import TripleceViral from '@/components/icons/Imunizacao/VacinaIdadeCerta/TripleceViral'

export default {
  name: 'VacinaIdadeCerta',
  metaInfo: {
    title: 'Vacina idade certa',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    Covid19Infantil,
    Varicela,
    Dtp,
    Pneumo,
    TripleceViral,
  },
  computed: {
    cards() {
      return this.$store.state?.permissoes?.vacina_idade_certa
    },
  },
  data() {
    return {}
  },
}
</script>

<style></style>
